module.exports = __webpack_public_path__ + "img/CO_KHI_XAY_DUNG.61eca57a.svg";